// @flow

import Scroll from '../components/Scroll';
import Notifications from '../constants/Notifications';
import DataLayerEvents from '../constants/DataLayer/EventNames';
import ProductGenerator from './abstract/ProductGenerator';
import Template from '../classes/Template';
import { clearChildElements } from '../classes/Helpers';
import EventNames from '../constants/EventNames';

export default class ProductOverview extends ProductGenerator {
  #loader: HTMLElement | null;
  #scrollComponent: Scroll = new Scroll();
  #skeletonTemplate: ?HTMLElement;

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    const loader: HTMLElement | null = pEl.querySelector('[ref="loader"]');
    if (loader) {
      this.#loader = loader;
    }

    if (this.el.getElementsByRef('product-skeleton')) {
      this.#skeletonTemplate = Template.getContent(this.el.getElementByRef('product-skeleton'));
    }

    this.addListener(Notifications.PAGINATE, this.onPaginate);
    this.addListener(Notifications.FILTER, () => this.addSkeleton());
    this.addListener(Notifications.SORT, () => this.addSkeleton());
    this.addListener(Notifications.FILTERED, this.handle);
    this.addListener(Notifications.PAGINATED, this.handle);
  }

  /**
   * Executes when the user paginates, but the API is not executed yet
   */
  onPaginate(): void {
    this.addSkeleton();
    this.#scrollComponent.scroll();
  }

  /**
   * Handle incoming notifications
   */
  handle(data: Object): void {
    const responseData: Object = data.data.productsData || data.data.pagination;
    if (!responseData) {
      console.error('No product data available');
    }

    if (
      !data.data.dataLayer ||
      !data.data.dataLayer.hasOwnProperty('productImpressions') ||
      !data.data.dataLayer.productImpressions.hasOwnProperty('overview')
    ) {
      return;
    }

    const productsData: Object = responseData.data;
    if (!productsData) return;

    this.createNewProducts(
      productsData,
      data.data.dataLayer.productImpressions.overview
    );

    if (this.#loader) {
      this.el.appendChild(this.#loader);
    }

    this.informOtherComponents(productsData);
    if (productsData.length) {
      const insiderList = productsData.filter((product: Object) => {
        return product.variants.length > 0;
      }).map((product: Object) => {
        return {
          id: product.variants[0].sku ?? '',
          taxonomy: product.category.split('/'),
          custom: product.custom
        };
      });

      this.dispatch({
        event: DataLayerEvents.SET_INSIDER_LIST,
        Insider: true,
        data: {
          items: insiderList
        }
      });
    }
  }

  /**
   * Inform other components if there are products or not
   */
  informOtherComponents(products: Array<Object>): void {
    if (!products.length) {
      this.notify(Notifications.PRODUCTS_NOT_FOUND);
      return;
    }

    this.notify(Notifications.PRODUCTS_FOUND);
  }

  /**
   * adds skeleton products to the view
   */
  addSkeleton() {
    if (this.#skeletonTemplate) {
      clearChildElements(this.el);
      for (let i = 0; i < 24; i++) {
        const clone = this.#skeletonTemplate.cloneNode(true);
        this.el.appendChild(clone);
      }
    }
  }
}
